import {useSearchParams} from 'react-router-dom';
import {QRCodeSVG} from 'qrcode.react';

import {isServiceDomain} from '@zzng/common/utils/isServiceDomain';

import PageLayout from '@/shared/components/PageLayout';

const DesktopGuide = () => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirectUrl') ?? '';
  const qrUrl = isServiceDomain(redirectUrl) ? redirectUrl : `${location.origin}/home`;

  return (
    <PageLayout tiara={false} className="container-bridge">
      <div className="group_cont">
        <strong className="tit_cont">
          <em className="emph_tit">디지털카드 서비스</em>는
          <br />
          <em className="emph_tit">모바일</em>에서 이용해 주세요.
        </strong>
        <div className="txt_cont">
          <span className="qr_code">
            <span className="screen_out">모바일 디지털카드 서비스 바로가기 QR코드 이미지</span>
            <QRCodeSVG width={74} height={74} value={qrUrl} />
          </span>
          <p className="txt_qr">
            <em className="emph_txt">QR코드</em>를 스캔하거나, 카카오톡 실행 후 <em className="emph_txt">더보기</em>에서
            <br />
            <em className="emph_txt">디지털카드 서비스</em>를 이용해 보세요.
          </p>
        </div>
      </div>
      <div className="group_visual">
        <img
          src="https://t1.kakaocdn.net/zzng_static/images/20241018_131614/idcard/bridge/img_mobile_241106.png"
          className="img_g"
          alt="bridge_image"
        />
      </div>
    </PageLayout>
  );
};

export default DesktopGuide;
